import { Card, CardContent, LinearProgress, MenuItem, TextField, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import { useReportWritersAndReviewer } from '../../../common/CommonQueries';
import { Autocomplete } from '@material-ui/lab';

export const NoteReviewer = ({ taggedReviewer, setTaggedReviewer, isNew }: any) => {


    const [noteType, setNoteType] = useState('');

    // const { data: reviewer = [], isLoading: isLoadingUsers } = useReviewer();
    const {
        error: errorReportWriter,
        data: reviewer = [],
        isLoading: isLoadingUsers,
        isError: isErrorReportWriter,
    } = useReportWritersAndReviewer();



    if (isLoadingUsers) {
        return (
            <>
                <Card style={{ marginTop: 12 }}>
                    <CardContent>
                        <Typography variant="h6">Reviewer:</Typography>
                        <LinearProgress />
                    </CardContent>
                </Card>
            </>
        );
    }
    const handleChange = (event: any, value: any) => {
        const selectedId = event.target.value;
      
        if (value) {
            const selectedReviewer = reviewer.find((r: any) => r.id === value.id);
            if (selectedReviewer) {
                setTaggedReviewer(selectedReviewer);
            }
        } else {
            setTaggedReviewer(null);
        }
    };
    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant="h6">Reviewer:</Typography>
                    {/* <TextField
                        id="noteType"
                        type="text"
                        data-testid="noteType"
                        name="noteType"
                        onChange={handleChange}
                        select={true}
                        fullWidth

                        value={taggedReviewer?.id || ""}
                    >
                        {
                            reviewer.map((type: any) => (
                                <MenuItem
                                    key={type.id}
                                    value={type.id}

                                   
                                >
                                    {type.username}
                                </MenuItem>
                            ))}
                    </TextField> */}

                    <Autocomplete
                        options={reviewer}
                        getOptionLabel={(option: any) => option.username || ""}
                        value={taggedReviewer || null}
                        onChange={handleChange}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Select Reviewer"
                                variant="standard"
                                fullWidth
                            />
                        )}
                    />
                </CardContent>
            </Card>
        </>
    )
}


